import React, { useState } from "react";
import "./Header.scss";

function Header({ cart, setCart }) {
    const [onCartBtn, setOnCartBtn] = useState(false);

    function handleOnCartBtn() {
        setOnCartBtn(!onCartBtn);
    }

    function handleDeleteCartProduct(indexProduct) {
        setCart(cart.filter((product, index) => index !== indexProduct));
    }

    return (
        <div className="header">
            <div className="header__left">
                <div className="header__logo">
                    <img src="./images/logo.svg" />
                </div>
                <div className="header__nav">
                    <p>Collections</p>
                    <p>Men</p>
                    <p>Women</p>
                    <p>About</p>
                    <p>Contact</p>
                </div>
            </div>
            <div className="header__right">
                <div className="header__cart-btn" onClick={handleOnCartBtn}>
                    <img src="./images/icon-cart.svg" />
                    <div className="products-number">{cart.length}</div>
                </div>

                {onCartBtn && (
                    <div className="header__cart">
                        <div className="cart__title">Cart</div>

                        {cart.length ? (
                            <React.Fragment>
                                <div className="products-list">
                                    {cart.map((product, index) => (
                                        <div className="product" key={index}>
                                            <div className="product__image">
                                                <img src={product.image} />
                                            </div>
                                            <div className="product__info">
                                                <div className="product__name">
                                                    {product.name}
                                                </div>
                                                <div className="product__price">
                                                    ${product.cost} x{" "}
                                                    {product.quality}
                                                    <span>
                                                        $
                                                        {product.cost *
                                                            product.quality}
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className="delete__product"
                                                onClick={() => {
                                                    handleDeleteCartProduct(
                                                        index
                                                    );
                                                }}
                                            >
                                                <img src="./images/icon-delete.svg" />
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="cart__checkout">Checkout</div>
                            </React.Fragment>
                        ) : (
                            <div className="cart--empty">
                                Your cart is empty
                            </div>
                        )}
                    </div>
                )}

                <div className="header__avatar">
                    <img src="./images/image-avatar.png" />
                </div>
            </div>
        </div>
    );
}

export default Header;
